import { render, staticRenderFns } from "./PanelMiniHeader.vue?vue&type=template&id=0ceddce8&"
import script from "./PanelMiniHeader.vue?vue&type=script&lang=js&"
export * from "./PanelMiniHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanelMiniHeader.vue?vue&type=style&index=0&id=0ceddce8&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ceddce8')) {
      api.createRecord('0ceddce8', component.options)
    } else {
      api.reload('0ceddce8', component.options)
    }
    module.hot.accept("./PanelMiniHeader.vue?vue&type=template&id=0ceddce8&", function () {
      api.rerender('0ceddce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelMiniHeader.vue"
export default component.exports